import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=4a0c08fa&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=4a0c08fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c08fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0c08fa')) {
      api.createRecord('4a0c08fa', component.options)
    } else {
      api.reload('4a0c08fa', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=4a0c08fa&scoped=true&", function () {
      api.rerender('4a0c08fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mwj2zezmXecV/JS/comp/GuestBoxKids.vue"
export default component.exports